<script>
import page from '~/marketplace-front-core/pages/products'
export default page
</script>
